import type { FaqCategoryKey } from './types';

export const FAQ_CATEGORIES: { key: FaqCategoryKey; label: string }[] = [
  { key: 'over_planly', label: 'Over Planly' },
  { key: 'planning', label: 'Planning' },
  { key: 'smart_planner', label: 'Planly Smart Planner+' },
  { key: 'pickup_handin', label: 'Pickup & Hand-in' },
  { key: 'dashboard', label: 'Dashboard' },
];
